import { NotebookItem } from "vbook-ui-components/src/notebook/store/models/NotebookItem";
import { ValueUtils } from "../../../utils/ValueUtils";

import './text-marginalia.scss';
import { GlobalStateInfo } from "../../../utils/GlobalStateInfo";
import EventUtils from "../../../utils/EventUtils";
import { INotesData } from "../../../services/textAddonsService/ITextAddonsService";
import Note from "../../../models/Note";
import { NotebookItemNote } from "vbook-ui-components/src/notebook/store/models/NotebookItemNote";
import { ReviewComment, ReviewCommentStatus } from "vbook-ui-components/src/notebook/store/models/ReviewComment";
import DOMUtils from "../../../utils/DOMUtils";

class TextMarginaliaManagerClass {
    constructor(){
        this.handleResizeStop = this.handleResizeStop.bind(this);
        
        $(document).on("click", ".text-marginalia-toggle-more", e => {
            this.toggleTextMarginaliaShowMore($(e.target).closest(".text-marginalia-container"));
        });

        $(document).on("click", ".text-marginalia-item", e => {
            const $target = $(e.target);
            
            if($target.attr("data-notebook-item-id")){
                $(document).trigger("showReviewComment", [$target.attr("data-notebook-item-id"), $target.closest(".readable-text").attr("data-hash")])
            }
            else if($target.attr("data-note-id")){
                $(document).trigger("noteOpenRequested", [$target.attr("data-note-id")]);
            }
        });

        $(document).on("click", ".text-marginalia-icon-container", e => {
            const $target = $(e.target);
            const $textMarginaliaItem = $target.closest(".text-marginalia-container").find(".text-marginalia-item").first();
            
            if($textMarginaliaItem.attr("data-notebook-item-id")){
                $(document).trigger("showReviewComment", [$textMarginaliaItem.attr("data-notebook-item-id"), $target.closest("[refid]").attr("data-hash")]);
            }
            else if($textMarginaliaItem.attr("data-note-id")){
                $(document).trigger("noteOpenRequested", [$textMarginaliaItem.attr("data-note-id"), $textMarginaliaItem.closest("[refid]").attr("data-hash") || $textMarginaliaItem.closest("[refid]").attr("refid")]);
            }
        });

        $(document).on("showAllTextMarginalia", (e, hash: string) => {
            this.showAllTextMarginalia($(`[refid='${hash}'],[data-hash='${hash}']`).find(".text-marginalia-container"));
        });

        $(document).on("hideExcessTextMarginalia", (e, hash: string) => {
            this.hideExcessTextMarginalia($(`[refid='${hash}'],[data-hash='${hash}']`).find(".text-marginalia-container"));
        });

        $(window).on("resizestop", this.handleResizeStop);

        this.handleTextMarginaliaMouseEnter = this.handleTextMarginaliaMouseEnter.bind(this);
        this.handleTextMarginaliaMouseLeave = this.handleTextMarginaliaMouseLeave.bind(this);
    }
    
    public initialize(){}

    public removeAllReviewMarginalia(){
        $(".text-marginalia-container").remove();
    }

    public renderNotebookItems(originalNotebookItems: NotebookItem[]){
        let notebookItems = (originalNotebookItems || []).concat([]);
        if(GlobalStateInfo.bookElement && GlobalStateInfo.bookElement.shortName){
            notebookItems = notebookItems.filter(it => it.notebookItemLocation.elementId == GlobalStateInfo.bookElement.shortName);
        }
        
        notebookItems.sort((a, b) => a.notebookItemLocation.contentOrdinal - b.notebookItemLocation.contentOrdinal);

        const notebookItemsByParagraph = this.groupNotebookItemsByParagraphs(notebookItems);

        ValueUtils.asyncForIn(notebookItemsByParagraph, (hash: string) => {
            const contentIdOrderedMap = this.groupNotebookItemsByParagraphOrdinals(notebookItemsByParagraph[hash])

            for(const contentId in contentIdOrderedMap){
                this.renderNotebookItemsInParagraph(hash, contentId, contentIdOrderedMap[contentId]);
            }
        }, () => {}, 16);
    }

    public renderNotes(notesData: INotesData){
        if(notesData == null || notesData.bookElementNotes == null || notesData.bookElementNotes.length == 0) {
            return;
        }

        const bookElementNotes = notesData.bookElementNotes.concat([]);
        const notesByParagraph = this.groupNotesByParagraphs(bookElementNotes)

        ValueUtils.asyncForIn(notesByParagraph, (key: string) => {
            this.renderNotesInParagraph(key, notesByParagraph[key]);
        }, () => {}, 16);
    }

    public updateNotebookItem(notebookItem: NotebookItem){
        if(notebookItem == null) { return; }

        const $listItem = $(`[data-notebook-item-id='${notebookItem.id}']`);
        
        if(notebookItem.notes && notebookItem.notes[0]){
            if(notebookItem instanceof ReviewComment){
                $listItem.toggleClass("closed", notebookItem.status == ReviewCommentStatus.Closed);
            }
            
            $listItem.text(this.getNoteTextBody(notebookItem.notes[0]));
            this.adjustTextMarginaliaLayout($listItem.closest(".text-marginalia-container"));
        }
        else {
            this.deleteNotebookItem(notebookItem);
        }
    }

    public updateNote(noteText: string, noteID: number) {
        if(!noteID) { return; }

        const $listItem = $(`[data-note-id='${noteID}']`);
        
        if(noteText){
            $listItem.text(noteText);
            this.adjustTextMarginaliaLayout($listItem.closest(".text-marginalia-container"));
        }
        else {
            this.deleteNote(noteID);
        }
    }

    public deleteNotebookItem(notebookItem: NotebookItem){
        if(notebookItem == null) { return; }

        const $listItem = $(`[data-notebook-item-id='${notebookItem.id}']`);
        const $textMarginaliaContainer = $listItem.closest(".text-marginalia-container");
        $listItem.remove();
        
        this.adjustTextMarginaliaLayout($textMarginaliaContainer);
    }

    public deleteNote(noteID: any) {
        const $listItem = $(`[data-note-id='${noteID}']`);
        const $textMarginaliaContainer = $listItem.closest(".text-marginalia-container");
        $listItem.remove();
        
        this.adjustTextMarginaliaLayout($textMarginaliaContainer);
    }

    public appendNote($textFragment: JQuery, noteText: string, noteID: any): any {
        if(!noteText || !noteID || $textFragment == null || $textFragment.length == 0){ return; }

        const $textMarginaliaContainer = $textFragment.find(".text-marginalia-container");

        const dummyNote = new Note(noteID, "", 0, $textFragment.attr("refid"), $textFragment.attr("data-hash"), "", noteText, "", 0, 0, 0);
        
        if($textMarginaliaContainer.length > 0){
            const noteHtml = this.renderNotesAsTextMarginaliaItems([dummyNote]);
            const noteIds = [];

            $textMarginaliaContainer.find("[data-note-id]").each((index, element) => {
                noteIds.push(+$(element).attr("data-note-id"));
            });
            
            for(let i = 0; i < noteIds.length; i++){
                const currentNoteId = noteIds[i];
                
                if(dummyNote.id < currentNoteId){
                    $textMarginaliaContainer.find(".text-marginalia-container-list-container").prepend(noteHtml);
                    break;
                }

                if(dummyNote.id > currentNoteId){
                    $(noteHtml).insertAfter($textMarginaliaContainer.find(`[data-note-id='${currentNoteId}']`));
                    break;
                }

                if(i == noteIds.length - 1){
                    $textMarginaliaContainer.find(".text-marginalia-container-list-container").append(noteHtml);
                }
            }

            this.adjustTextMarginaliaLayout($textMarginaliaContainer);
        }
        else {
            this.renderNotesInParagraph($textFragment.attr("data-hash") || $textFragment.attr("refid"), [dummyNote]);
        }
    }

    public appendNotebookItem(notebookItem: NotebookItem){
        if(!notebookItem) { return; }
        
        const readableText = DOMUtils.getAssociatedTextFragment(notebookItem.notebookItemLocation.contentId, notebookItem.notebookItemLocation.contentOrdinal);
        
        if(readableText == null) { return; }

        const $readableText = $(readableText);
        const $textMarginaliaContainer = $readableText.find(".text-marginalia-container");

        if($textMarginaliaContainer.length > 0){
            const notebookItemHtml = this.renderNotebookItemsAsTextMarginaliaItems([notebookItem]);

            const textOffsets = [];
            const noteBookItemIds = [];

            $textMarginaliaContainer.find("[data-text-offset]").each((index, element) => {
                textOffsets.push(+$(element).attr("data-text-offset"));
                noteBookItemIds.push(+$(element).attr("data-notebook-item-id"));
            });
            
            for(let i = 0; i < textOffsets.length; i++){
                const currentTextOffset = textOffsets[i];
                const currentNotebookItemId = noteBookItemIds[i];
                
                if(notebookItem.textOffset < currentTextOffset){
                    $textMarginaliaContainer.find(".text-marginalia-container-list-container").prepend(notebookItemHtml);
                    break;
                }

                if(notebookItem.textOffset > currentTextOffset){
                    $(notebookItemHtml).insertAfter($textMarginaliaContainer.find(`[data-notebook-item-id='${currentNotebookItemId}']`));
                    break;
                }

                if(i == textOffsets.length - 1){
                    $textMarginaliaContainer.find(".text-marginalia-container-list-container").append(notebookItemHtml);
                }
            }

            this.adjustTextMarginaliaLayout($textMarginaliaContainer);
        }
        else {
            this.renderNotebookItemsInParagraph($readableText.attr("data-hash"), $readableText.attr("refid"), [notebookItem]);
        }
    }

    private renderNotebookItemsInParagraph(dataHash: string, ordinal: string | number, notebookItems: NotebookItem[]){
        const readableText = DOMUtils.getAssociatedTextFragment(dataHash, ordinal);
        if(readableText == null) { return; }

        const $readableText = $(readableText);

        let $textMarginaliaContainer = $readableText.find(".text-marginalia-container");

        if($textMarginaliaContainer.length == 0){
            $readableText.append(/*html*/
                `<div class="text-marginalia-container">
                    <div class="text-marginalia-icon-container">
                        <i class='fa ${GlobalStateInfo.bookElement.reviewVersion > 0 ? 'fa-comment-edit' : 'fa-sticky-note'} text-marginalia-icon'></i>
                        <span class='text-marginalia-counter-container'></span>
                    </div>
                    <div class='text-marginalia-container-list-container'></div>
                    <span class="text-marginalia-toggle-more">${this.getShowMoreLabel(notebookItems.length)}</span>
                </div>`
            );
            
            $textMarginaliaContainer = $readableText.find(".text-marginalia-container");
        }

        $textMarginaliaContainer.find(".text-marginalia-container-list-container").html(this.renderNotebookItemsAsTextMarginaliaItems(notebookItems));
        this.adjustTextMarginaliaLayout($readableText.find(".text-marginalia-container"));

        $textMarginaliaContainer.find(".text-marginalia-item").on("mouseenter", this.handleTextMarginaliaMouseEnter);
        $textMarginaliaContainer.find(".text-marginalia-item").on("mouseleave", this.handleTextMarginaliaMouseLeave);
    }

    private renderNotesInParagraph(paragraphId: string, notes: Note[]){
        if(notes == null || notes.length == 0) { return; }
        const firstNote = notes[0]
        
        const readableText = (firstNote.contentHash && document.querySelector(`[data-hash='${firstNote.contentHash}']`)) 
                        || document.querySelector(`[refid='${firstNote.contentID}']`);
        
        if(!readableText) { return; }

        const $readableText = $(readableText);

        let $textMarginaliaContainer = $readableText.find(".text-marginalia-container");

        if($textMarginaliaContainer.length == 0){
            $readableText.append(/*html*/
                `<div class="text-marginalia-container">
                    <div class="text-marginalia-icon-container">
                        <i class='fa fa-sticky-note text-marginalia-icon'></i>
                        <span class='text-marginalia-counter-container'></span>
                    </div>
                    <div class='text-marginalia-container-list-container'></div>
                    <span class="text-marginalia-toggle-more">${this.getShowMoreLabel(notes.length)}</span>
                </div>`
            );
            
            $textMarginaliaContainer = $readableText.find(".text-marginalia-container");
        }

        $textMarginaliaContainer.find(".text-marginalia-container-list-container").html(this.renderNotesAsTextMarginaliaItems(notes));
        this.adjustTextMarginaliaLayout($readableText.find(".text-marginalia-container"));
        
        $textMarginaliaContainer.find(".text-marginalia-item").on("mouseenter", this.handleTextMarginaliaMouseEnter);
        $textMarginaliaContainer.find(".text-marginalia-item").on("mouseleave", this.handleTextMarginaliaMouseLeave);
    }

    private adjustTextMarginaliaLayout($textMarginaliaContainer: JQuery){  
        if($textMarginaliaContainer == null || $textMarginaliaContainer.length == 0) { return; }      
        
        $textMarginaliaContainer.css({
            width: $(window).width() - 10 - $textMarginaliaContainer.offset().left
        });

        const textMarginaliaContainer = $textMarginaliaContainer.get(0);
        const hasMoreThanOneItem = textMarginaliaContainer.querySelectorAll(".text-marginalia-item").length > 1;

        $textMarginaliaContainer.toggleClass("has-multiple-children", hasMoreThanOneItem);
        const contentFitsVertically = textMarginaliaContainer.scrollHeight <= textMarginaliaContainer.offsetHeight;

        if(!contentFitsVertically){
            const lineHeight = 20;
            const itemMargin = 10;
            
            $textMarginaliaContainer.addClass("has-additional-content");
            
            const textMarginaliaItems = textMarginaliaContainer.querySelectorAll(".text-marginalia-item");
            
            for(let i = 0; i < textMarginaliaItems.length; i++){
                const item = $(textMarginaliaItems[i]);
                const $item = $(item);
                
                const startItemPosition = $item.position().top;
                const endItemPosition = startItemPosition + $item.height();
                
                if(endItemPosition > textMarginaliaContainer.offsetHeight){
                    const startTextPosition = startItemPosition + (i > 0 ? itemMargin : 0);
                    const visibleItemPart = textMarginaliaContainer.offsetHeight - startTextPosition;
                    const fullyVisibleLineCount = Math.floor(visibleItemPart/lineHeight);

                    $textMarginaliaContainer.css({
                        "height": startTextPosition + fullyVisibleLineCount*lineHeight
                    });
                    
                    break;
                }
            }
        }
        else if(hasMoreThanOneItem){
            $textMarginaliaContainer.addClass("has-additional-content");
        }
        else {
            $textMarginaliaContainer.removeClass("has-additional-content");
            $textMarginaliaContainer.css("height", "auto");
        }

        $textMarginaliaContainer.find(".text-marginalia-counter-container").text(textMarginaliaContainer.querySelectorAll(".text-marginalia-item").length);
        this.renderTextMarginaliaShowMoreLabel($textMarginaliaContainer);
    }

    private renderNotesAsTextMarginaliaItems(notes: Note[]): string {
        const noteIdMap = {};
        return notes.sort((a, b) => a.id - b.id).filter(note => {
            if(!noteIdMap[note.id]){
                noteIdMap[note.id] = true;
                return true;
            }

            return false;
        }).map(note => {            
            return /*html */`<div class="text-marginalia-item" data-note-id="${note.id}">${note.noteText}</div>`;
        }).join("");
    }

    private renderNotebookItemsAsTextMarginaliaItems(notebookItems: NotebookItem[]): string {
        return notebookItems.sort((a, b) => a.notebookItemLocation.textOffset - b.notebookItemLocation.textOffset).map(notebookItem => {
            if(!notebookItem.notes || notebookItem.notes.length == 0) { return ""; }

            let additionalClasses = "";
            let tags = "";

            if(notebookItem instanceof ReviewComment){
                if(notebookItem.status == ReviewCommentStatus.Closed){
                    additionalClasses = "closed";
                }
                
                if(notebookItem.userMonicker != null){
                    tags = notebookItem.userMonicker.tags
                }
            }
            
            return /*html */`<div class="text-marginalia-item ${additionalClasses}" data-notebook-item-id="${notebookItem.id}" data-user-tags="${tags}" data-text-offset="${notebookItem.textOffset}">${this.getNoteTextBody(notebookItem.notes[0])}</div>`;
        }).join("");
    }

    private getNoteTextBody(note: NotebookItemNote): string {
        const text = note.text;
        let monicker = !GlobalStateInfo.book.userIsReviewer ? note.userMonicker.getDisplayName() : "";
        let tags = !GlobalStateInfo.book.userIsReviewer && note.userMonicker != null ? note.userMonicker.tags : "";

        return monicker ? `<span class="_monicker" data-tags="${tags}">${monicker}</span>: ${text}`
                        : text;
    }

    private toggleTextMarginaliaShowMore($textMarginaliaContainer: JQuery){
        $textMarginaliaContainer.toggleClass("show-everything");
        this.renderTextMarginaliaShowMoreLabel($textMarginaliaContainer);
    }

    private renderTextMarginaliaShowMoreLabel($textMarginaliaContainer: JQuery){
        $textMarginaliaContainer.find(".text-marginalia-toggle-more").text(
            $textMarginaliaContainer.is(".show-everything") ? "show less" 
                                                            : this.getShowMoreLabel($textMarginaliaContainer.find(".text-marginalia-item").length)
        );
    }

    private showAllTextMarginalia($textMarginaliaContainer: JQuery){
        $textMarginaliaContainer.addClass("show-everything");
        this.renderTextMarginaliaShowMoreLabel($textMarginaliaContainer);
    }

    private hideExcessTextMarginalia($textMarginaliaContainer: JQuery){
        $textMarginaliaContainer.removeClass("show-everything");
        this.renderTextMarginaliaShowMoreLabel($textMarginaliaContainer);
    }

    private getShowMoreLabel(itemCount: number){
        return itemCount <= 1 ? "show more" : `show ${itemCount - 1} more`;
    }

    private groupNotebookItemsByParagraphs(notebookItems: NotebookItem[]): IParagraphNoteItemsMap {
        const map: IParagraphNoteItemsMap = {};

        for(const notebookItem of notebookItems){
            if(!map[notebookItem.notebookItemLocation.contentId]){
                map[notebookItem.notebookItemLocation.contentId] = [];
            }

            map[notebookItem.notebookItemLocation.contentId].push(notebookItem);
        }

        for(const key in map){
            map[key].sort((a, b) => a.dateCreated.getTime() - b.dateCreated.getTime());
        }

        return map;
    }

    private groupNotebookItemsByParagraphOrdinals(notebookItems: NotebookItem[]): IParagraphNoteItemsMap {
        const map: IParagraphNoteItemsMap = {};

        for(const notebookItem of notebookItems){
            if(!map[notebookItem.notebookItemLocation.contentOrdinal]){
                map[notebookItem.notebookItemLocation.contentOrdinal] = [];
            }

            map[notebookItem.notebookItemLocation.contentOrdinal].push(notebookItem);
        }

        for(const key in map){
            map[key].sort((a, b) => a.dateCreated.getTime() - b.dateCreated.getTime());
        }

        return map;
    }

    private groupNotesByParagraphs(bookElementNotes: Note[]): IParagraphNotesMap {
        const map: IParagraphNotesMap = {};

        for(const note of bookElementNotes){
            const key = note.contentHash || note.contentID;
            if(!map[key]){
                map[key] = [];
            }

            map[key].push(note);
        }

        for(const key in map){
            map[key].sort((a, b) => a.id - b.id);
        }

        return map;
    }

    private handleResizeStop(){
        EventUtils.setTimeout(() => {
            $(".text-marginalia-container").each((index, textMarginaliaContainer) => {
                this.adjustTextMarginaliaLayout($(textMarginaliaContainer));
            });
        }, 64);
    }

    private handleTextMarginaliaMouseEnter(e){
        $(e.currentTarget).parents(".readable-text").addClass("paragraph-focused");
    }

    private handleTextMarginaliaMouseLeave(e){
        const $currentTarget = $(e.currentTarget);
        
        if($currentTarget.parent(".text-marginalia-container-list-container").find(".text-marginalia-item.selected").length > 0){
            return;
        }

        $currentTarget.parents(".readable-text").removeClass("paragraph-focused");
    }
}

interface IParagraphNoteItemsMap {
    [key: string]: NotebookItem[];
}

interface IParagraphNotesMap {
    [key: string]: Note[];
}

export const TextMarginaliaManager = new TextMarginaliaManagerClass();